/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('AvailableDayHrView',["$log","DayHrData","Period",
        function ($log,DayHrData,Period){
        //special object contains available period for a day and an hr
        var  AvailableDayHrView = function(dayHr,hrView,aDayView)
        {
            this.hrView = hrView;
            this.dayHrIndex = -1;      // index inside DayHrData
            this.aDayView = aDayView;
            this.availablePeriods = []; // periods availables

            //Load activities of dayhr
            if (dayHr !== undefined && dayHr)
            {
                this.dayHrIndex = DayHrData.getIndexOf(dayHr);
                for (let i = 0; i < dayHr.availablePeriods.length; i++) {
                    this.availablePeriods.push(new Period(dayHr.availablePeriods[i]))
                }
                if (this.availablePeriods.length > 0) {
                    this.availablePeriods.sort(Period.prototype.compare);
                }
            }

        };

        AvailableDayHrView.prototype.getModel= function()
        {

            if (this.dayHrIndex!=-1)
            {
                return DayHrData.getByIndex(this.dayHrIndex);
            }
            return null;
        };

        AvailableDayHrView.prototype.isAvailableForBookingView = function(bookingView,cPeriod)
        {
            var isAvailable = false;
            isAvailable = this.isAvailableForPeriod(bookingView.period,cPeriod);
/*
            for (var i= 0; i<bookingView.bookingServicesView.length;i++)
            {
                isAvailable = this.isAvailableForPeriod(bookingView.bookingServicesView[i].period);
            }
*/
            return isAvailable;
        };

        AvailableDayHrView.prototype.isAvailableForBookingServiceView  = function(bsView) {
            if (!bsView || !bsView.period) {
                return false;
            }
            if (!this.hrView.knowsServiceView(bsView.serviceView)) {
                return false;
            }
            return this.isAvailableForPeriod(bsView.period);
        };

        AvailableDayHrView.prototype.isAvailableForPeriod = function(period) {
            let isAvailable = false;
            if (period) {
                for (let i= 0; i<this.availablePeriods.length && !isAvailable && this.availablePeriods[i].start.getTime()<=period.start.getTime();i++) {
                    isAvailable = this.availablePeriods[i].contains(period);
                }
            }
            return isAvailable;
        };

        AvailableDayHrView.prototype.getAvailablePeriodByStart = function(start) {
            for (let i= 0; i<this.availablePeriods.length && this.availablePeriods[i].start.getTime()<=start.getTime();i++) {//ordered then test if out of period
                if (this.availablePeriods[i].start.getTime()<=start.getTime() && this.availablePeriods[i].end.getTime()>=start.getTime() &&
                    this.availablePeriods[i].duration!=0) {
                    return this.availablePeriods[i];
                }
            }
            return null;
        };

        AvailableDayHrView.prototype.getNextAvailablePeriodByStart = function(start) {
            for (let i= 0; i<this.availablePeriods.length;i++) {
                if (this.availablePeriods[i].start.getTime()>=start.getTime() && this.availablePeriods[i].duration!=0) {//return first next
                    return this.availablePeriods[i];
                }
            }
            return null;
        };

        return  AvailableDayHrView;
    }]);


// WEBPACK FOOTER //
// ./js/services/customerSite/views/AvailableDayHrView.js